<template>
  <section>
    <div class="dialog-header">
      <h1>{{ name }}</h1>
      <close-button @click="$emit('close')" class="close-button"></close-button>
    </div>
    <main class="dialog-content">
      <p>
        Voor de beste printkwaliteit raden wij aan afbeeldingen te gebruiken met
        een minimale resolutie van 200 DPI. <br />
        De volgende pagina's bevatten één of meer afbeelding met een lagere
        resolutie:
      </p>
      <!--  <ul>
        <li v-for="(val, key) in ldpis" :key="key">{{ key }}: {{ val }} DPI</li>
      </ul> -->
      <table>
        <thead>
          <tr>
            <th>Pagina</th>
            <th>Resolutie</th>
          </tr>
        </thead>
        <tr v-for="(val, key) in ldpis" :key="key">
          <td class="page">{{ key }}</td>
          <td class="dpi">{{ val }} DPI</td>
        </tr>
      </table>
    </main>
  </section>
</template>
<script>
export default {
  props: ['dpis', 'name'],
  computed: {
    ldpis() {
      const pageLdpi = {}
      this.dpis.forEach((page) => {
        const lowestPageDpi = page.dpis.reduce((a, b) => Math.min(a, b))

        if (lowestPageDpi < 200) {
          pageLdpi[page.page] = lowestPageDpi
        }
      })

      return pageLdpi
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  text-align: left;
}

h1{
  word-wrap: break-word;
}

th {
  font-weight: 600;
}

.page {
  width: 50px;
}

.dialog-header {
  margin-bottom: -5px;
}

.dialog-content {
  max-height: 500px;
  overflow: auto;
  margin-bottom: 25px;
}
</style>
